import { useRoute } from 'vue-router'

import { RouteName } from '../types/navigation.types'
import { ResolvedNavItem } from './useResolvedNav'

export type ResolvedNavLink = Extract<ResolvedNavItem, { kind: 'link' }>

/**
 * Whether a resolved nav link is current: its own route is in the matched
 * chain, or one of the routes it claims through `activeFor` is.
 */
export function useNavActive() {
  const route = useRoute()

  const isActive = (item: ResolvedNavLink) =>
    route.matched.some(
      ({ name }) =>
        name === item.to.name ||
        (name !== undefined && item.activeFor?.includes(name as RouteName)),
    )

  return { isActive }
}
